<template>
    <v-container class="main-container overflow-auto pa-5 ma-0">
        <v-form ref="form" :disabled="!record.userCanSave(authUser)" @input="$emit('input', $event)">
            <v-row dense>
                <v-col cols="12" lg="4">
                    <h4>{{ $t('additional_info') }}</h4>
                </v-col>
            </v-row>
            <AdditionalInfoPanel :record="record" @save="onSave" />
        </v-form>
    </v-container>
</template>

<script>
import { Event } from '@/models/Event';
import getRulesMixin from '@/mixins/get-form-rules';
import AdditionalInfoPanel from '@/components/event/AdditionalInfoPanel.vue';
import { mapState } from 'vuex';

export default {
    name: 'EventEditAdditionalInfo',
    components: {
        AdditionalInfoPanel,
    },
    mixins: [getRulesMixin],

    props: {
        record: {
            type: Event,
            required: true,
        },
    },

    computed: {
        ...mapState('user', {
            authUser: 'record',
        }),
    },

    mounted() {
        this.validateForm();
    },

    methods: {
        onSave() {
            this.$emit('save');
        },

        validateForm() {
            this.$refs.form.validate();
        },
    },
};
</script>

<style lang="scss" scoped>
.main-container {
    max-width: inherit;
}
</style>
